import axios from "axios";
import { getAccountDetails, getUserDetails } from "../storage/localStorage";
import { showSnackbarSuccess } from "../events/snackbarEvents";
import { createStore } from "../../store";
const store = createStore();

const user = getUserDetails();
const account = getAccountDetails();
const instance = axios.create();
instance.defaults.headers.common["x-session-jwt"] = user
  ? user["session_jwt"] || null
  : null;
instance.defaults.headers.common["x-user-id"] = user ? user["id"] : null;
instance.defaults.headers.common["x-account-id"] = account
  ? account["id"]
  : null;
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      store.dispatch(
        showSnackbarSuccess(
          "Permission denied. You do not have access to this resource.",
          "error"
        )
      );
    }
    return Promise.reject(error);
  }
);
export default instance;

export const vanillaInstance = axios.create();

export function getHeaders() {
  return {
    "x-account-id": account["id"],
    "x-user-id": user["id"],
    ...(user["session_jwt"] && {
      "x-session-jwt": user["session_jwt"],
    }),
  };
}
